import React, { useState } from 'react';
import { Button, Modal, Form, Input, AutoComplete } from 'antd';

const AuctionAddForm = ({ visible, onCreate, onCancel }) => {
  
    const [autoCompleteResult, setAutoCompleteResult] = useState([]);
    const [form] = Form.useForm();

    const onWebsiteChange = (value) => {
        if (!value) {
          setAutoCompleteResult([]);
        } else {
          setAutoCompleteResult(['.com', '.org', '.net'].map((domain) => `${value}${domain}`));
        }
      };
    
      const websiteOptions = autoCompleteResult.map((website) => ({
        label: website,
        value: website,
      }));


  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="AuctionForm"
        initialValues={{
          AuctionID:'',
          AuctionName:'',
          AuctionAddress:'',
          AuctionWebsite:'',
          AuctionPhone:'',
      }}
      >
        <Form.Item
          name="AuctionName"
          label="Auction Name"
        >
          <Input />
        </Form.Item>
        <Form.Item name="AuctionAddress" label="Auction Address">
          <Input />
        </Form.Item>
        <Form.Item name='AuctionWebsite' label="Auction Website" >
        <AutoComplete options={websiteOptions} onChange={onWebsiteChange}>
            <Input/>
        </AutoComplete>
        </Form.Item>
        <Form.Item
          validateTrigger='onBlur'
          name='AuctionPhone' 
          label="Auction Phone"
          rules={[
            {required:true,
              message:'Please enter the Phone number'
            },
            {
              required:false,
              pattern: new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "g"),
              message:'Please enter the correct format'
            }
          ]}
        >
            <Input 
              addonBefore={'+1'}
            />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AuctionAdd = ( props ) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addAuction(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Add New Auction
      </Button>
      <AuctionAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default AuctionAdd